import { MetadataContent } from '@jutro/legacy/uiconfig';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import metadata from './SelectProducerCode.metadata.json5';
import styles from './SelectProducerCode.module.scss';
import { ProducerContext } from './SelectProducerCodeContext';

const SelectProducerCode = props => {
    const { hideMyWork, onValueChange } = props;
    const [availableProducerCode, setProducerCodeList] = useState([]);
    const { producerCodeList, producerCode, setProducerCode } =
        useContext(ProducerContext);

    const getSelectedProducerCode = useCallback(
        codeList => {
            if (!_.isEmpty(codeList)) {
                return _.some(codeList, { code: producerCode })
                    ? producerCode
                    : 'all';
            }

            return null;
        },
        [producerCode]
    );

    useEffect(() => {
        const sortedList = _.sortBy(producerCodeList, 'name').reverse();

        if (hideMyWork && !_.isEmpty(sortedList)) {
            const codeList = _.filter(
                sortedList,
                list => list.code !== 'myWork'
            );
            const code = getSelectedProducerCode(codeList);

            setProducerCode(code);

            if (onValueChange) {
                onValueChange(code);
            }

            setProducerCodeList(codeList);
        } else {
            setProducerCodeList(sortedList);
        }
        // execute once producerCodeList is populated
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [producerCodeList]);

    const handleValueChange = useCallback(
        code => {
            if (onValueChange) {
                onValueChange(code);
            }

            setProducerCode(code);
        },
        [onValueChange, setProducerCode]
    );

    const overrideProps = {
        availableProducerCode: {
            availableValues: availableProducerCode,
            value: getSelectedProducerCode(availableProducerCode),
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            handleValueChange,
        },
    };

    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            {...resolvers}
        />
    );
};

SelectProducerCode.propTypes = {
    hideMyWork: PropTypes.bool,
    onValueChange: PropTypes.func,
};
SelectProducerCode.defaultProps = {
    hideMyWork: true,
    onValueChange: undefined,
};

export default SelectProducerCode;
